import { Search, FileText, BookOpen, User, ScrollText, PenLine, Hash } from "lucide-react";

const ICONS: Record<string, typeof Search> = {
  query_events: Search,
  fetch_event: FileText,
  fetch_profile: User,
  lookup_kind: BookOpen,
  list_kinds: ScrollText,
  decode_nip19: Hash,
  whoami: User,
  draft_event: PenLine,
};

function describe(name: string, args: Record<string, unknown>): string {
  switch (name) {
    case "query_events": {
      const kinds = Array.isArray(args.kinds) ? `kinds ${(args.kinds as number[]).join(", ")}` : "events";
      const topic = args["#t"] ? ` #${(args["#t"] as string[]).join(", #")}` : "";
      const search = args.search ? ` matching "${args.search}"` : "";
      return `Querying relays for ${kinds}${topic}${search}`;
    }
    case "fetch_event":
      return `Fetching event ${String(args.identifier ?? "").slice(0, 24)}…`;
    case "fetch_profile":
      return `Fetching profile ${String(args.identifier ?? "").slice(0, 24)}…`;
    case "lookup_kind":
      return `Looking up kind ${args.kind}`;
    case "list_kinds":
      return "Listing known event kinds";
    case "decode_nip19":
      return `Decoding ${String(args.identifier ?? "").slice(0, 24)}…`;
    case "whoami":
      return "Checking who's logged in";
    case "draft_event":
      return `Drafting a kind ${args.kind} event`;
    default:
      return name;
  }
}

export function ToolActivity({ name, args }: { name: string; args: Record<string, unknown> }) {
  const Icon = ICONS[name] ?? Search;
  return (
    <div className="flex items-center gap-2 text-xs text-muted-foreground">
      <span className="flex h-5 w-5 items-center justify-center rounded-full bg-muted">
        <Icon className="h-3 w-3" />
      </span>
      <span className="font-mono">{describe(name, args)}</span>
    </div>
  );
}
